import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ChipFilter, IOption } from "../../../../components/Filters/ChipFilter";
import { useUsersContext } from "../../../../providers/Users/users-context";

export const UsersActiveFilter: FC = () => {
  const { filters, setFilters, tablePagination, setTablePagination } = useUsersContext();
  const { t } = useTranslation();
  const options: IOption<string>[] = [
    {
      value: "true",
      displayValue: t("basedata.users.table.filter.status.active"),
    },
    {
      value: "false",
      displayValue: t("basedata.users.table.filter.status.inactive"),
    },
  ];

  // IUsersFilter.active is boolean; ChipFilter works with string values ("true"/"false").
  // We convert at the boundary to keep both sides type-safe.
  const activeAsString = filters?.active !== undefined ? String(filters.active) : undefined;

  return (
    <ChipFilter
      possibleOptions={options}
      label={t("basedata.users.table.filter.status.text")}
      filter={activeAsString}
      setFilter={(x: string | undefined) => {
        const newFilter = { ...filters };
        newFilter.active = x !== undefined ? x === "true" : undefined;
        setFilters(newFilter);
        setTablePagination({ ...tablePagination, page: 0 });
      }}
    />
  );
};
